import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LeftNavigationService {
    private readonly chatShowed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private readonly chatSessionSelected$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

    showChat(): void {
        this.chatShowed$.next(true);
    }

    selectChatSession(sessionId: number | null): void {
        this.chatSessionSelected$.next(sessionId);
    }

    hideChat(): void {
        this.chatShowed$.next(false);
    }

    chatShowedChange(): Observable<boolean> {
        return this.chatShowed$.asObservable();
    }

    chatSessionSelectedChange(): Observable<number | null> {
        return this.chatSessionSelected$.asObservable();
    }
}
